export default {
  第一作者必须填写: 'O primeiro autor deve ser preenchido',
  自动保存: 'Salvamento automático',
  添加作者: 'Adicionar autor',
  修改作者: 'Revisão do autor',
  作者信息: 'Informação do autor',
  第一作者: 'Primeiro autor',
  其他作者: 'Outro autor',
  确定: 'Confirmar',
  取消: 'Cancelar',
  存为草稿: 'Guardar como rascunho',
  直接提交: 'Enviar diretamente',
  '勾选收集通讯作者时，手机邮箱必须至少有一项':
    'Selecionar coletar o autor como comunicador, o número de telefone e o e-mail deve ser pelo menos um',
  '请输入{0}字符': 'Por favor, insira {0} caracteres',
  '请输入至少{0}字符': 'Por favor, insira pelo menos {0} caracteres',
  '请输入最多{0}字符': 'Por favor, insira no máximo {0} caracteres',
  请填写完整的作者信息: 'Por favor, preencha as informações completas do autor',
  是否显示提交并继续: 'Mostrar enviar e continuar',
  是否唯一: 'É único'
}
